/* eslint filenames/match-regex: off */
import styled from 'styled-components'

export function EnterpriseBackground() {
  const StyledDiv = styled.div`
    @media screen and (min-width: 48rem) {
      background-attachment: fixed;
      background-image: url(${({image}: {image: string}) => image});
      background-position: bottom left;
      background-size: cover;
      grid-column: 1/7;
      margin-right: calc(var(--brand-Grid-spacing-column-gap) * -1);
    }
  `

  return <StyledDiv image={`/images/modules/site/landing-pages/contact-sales/enterprise.jpg`} />
}

try{ EnterpriseBackground.displayName ||= 'EnterpriseBackground' } catch {}